const INITIAL_STATE = {
  grupomotivosdesistencia: [],
  grupomotivodesistencia: null,
  grupoPagination: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GRUPODESISTENCIAS_FETCH':
      return { ...state, grupomotivosdesistencia: action.payload }
    case 'GRUPODESISTENCIA_FETCH':
      return { ...state, grupomotivodesistencia: action.payload }
    case 'GRUPODESISTENCIA_PAGINATION':
      return { ...state, grupoPagination: action.payload }
    default:
      return state
  }
}